interface FindingsCountCellProps {
  count: number | undefined;
}

export function FindingsCountCell({ count }: FindingsCountCellProps) {
  if (count === undefined || count === null) {
    return <span className="text-chariot-text-secondary text-sm">--</span>;
  }
  if (count === 0) {
    return <span className="text-chariot-text-secondary text-sm">0</span>;
  }
  return (
    <span
      className="text-sm font-medium text-[#afa3db]"
      aria-label={`${count} findings`}
    >
      {count}
    </span>
  );
}
